import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import Header from "components/common/Header/Header";
import ConfirmationModal from "components/common/Modal/ConfirmationModal";
import _ from "lodash";
import { apiGetRequest, apiPostRequest, apiPutRequest } from "helpers/Requests";
import { toast } from "react-toastify";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import InputCreationForm from "components/common/InputCreationForm/InputCreationForm";
import SectionCreationForm from "components/common/SectionCreationForm/SectionCreationForm";
import SideBar from "components/common/SideBar/SideBarNew";
import { LoginContext } from "helpers/LoginContext";
import CustomButton from "components/common/Button/CustomButton";
import Breadcrumb from "components/common/Breadcrumb";
import {
  SUPER_ADMIN_BREADCRUMB,
  SUPER_ADMIN_BREADCRUMBS_PAGES,
} from "Constants/BreadcrumbConstant";
import { parseBooleanVal } from "Utils/utils";
import SelectOption from "components/common/Select/Select";
import FormCategorySelect from "../shared/FormCategorySelect";
import { useLocation, useNavigate, useParams } from "react-router";
import { MdPublish } from "react-icons/md";
import { RiDraftFill } from "react-icons/ri";
import SweetAlertConfirmationModal from "components/common/SweetAlertConfirmation/SweetAlertConfirmation";
import { roleAccess } from "helpers/RolesPermission";
import { USER_ROLE } from "Constants/constant";
import apiCall from "store/services/sp.services";
import api from "store/services/sil.services";
import { FormBuilderSectionList } from "../shared/FormBuilderComponents";
import { FormBuilderExperienceControls } from "../shared/FormBuilderExperienceModal";
import PdfFormImportButton, {
  resolvePdfImportEndpoint,
} from "../shared/PdfFormImportButton";
import FormBuilderDiscardButton from "../shared/FormBuilderDiscardButton";
import {
  createFormBuilderSnapshot,
  emptyCreateFormData,
  formBuilderSnapshotsEqual,
} from "../shared/formBuilderSnapshotUtils";
import FormScopeBadge from "../shared/FormScopeBadge";
import {
  extractFormCategoriesFromResponse,
  resolveFormCategoryOptionForTemplate,
  resolveFormScopeFromRole,
} from "../shared/formCategoryUtils";

const CreateFormTemplate = (props) => {
  const { title, role } = props;
  const { sideBarPadding, isUserGracePeriodOver } = useContext(LoginContext);
  const navigate = useNavigate();
  const location = useLocation();
  const navigationPageHeading = location.state?.pageHeading;
  const openedFromClone = Boolean(location.state?.fromClone);

  const { form_uuid, form_status } = useParams();
  const [actionMode, setActionMode] = useState("add");
  const [showInputModal, setShowInputModal] = useState(false);
  const [showSectionModal, setShowSectionModal] = useState(false);
  const [showSubSectionModal, setShowSubSectionModal] = useState(false);
  const [formCategories, setFormCategories] = useState([]);
  const [formSubCategories, setFormSubCategories] = useState([]);
  const [selectedFormCategory, setselectedFormCategory] = useState(null);
  const [selectedformSubCategory, setSelectedFormSubCategory] = useState(null);
  const [formCatError, setFormCatError] = useState("");
  const [showSubSectionInputModal, setShowSubSectionInputModal] =
    useState(false);
  const [showEditSectionModal, setShowEditSectionModal] = useState(false);
  const [showEditSectionTitle, setShowEditSectionTitle] = useState(false);
  const [showEditSubSectionModal, setShowEditSubSectionModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [
    showSectionTitleConfirmationModal,
    setShowSectionTitleConfirmationModal,
  ] = useState(false);
  const [showSubSectionConfirmationModal, setShowSubSectionConfirmationModal] =
    useState(false);
  const [sectionIndex, setSectionIndex] = useState(null);
  const [subSectionIndex, setSubSectionIndex] = useState(null);
  const [fieldIndex, setFieldIndex] = useState(null);
  const [subFieldIndex, setSubFieldIndex] = useState(null);
  const [editData, setEditData] = useState(null);
  const [defaultFieldType, setDefaultFieldType] = useState(null);
  const [template, setTemplate] = useState([]);
  const [pdfImportReview, setPdfImportReview] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    form_category_id: null,
    form_sub_category_id: null,
    description: "",
  });
  const [decodedFormType, setDecodedFormType] = useState(null);
  const [categoriesLoaded, setCategoriesLoaded] = useState(false);
  const templateFetchStarted = useRef(false);
  const [showConfirmationModalPublish, setShowConfirmationModalPublish] =
    useState(false);
  const [showExitConfirmationModal, setShowExitConfirmationModal] =
    useState(false);
  const [baselineSnapshot, setBaselineSnapshot] = useState(null);

  const isCloneMode =
    actionMode === "edit" && decodedFormType === "publish";

  const isCreateFlow =
    title === "Create New Form" || isCloneMode;

  const isDraftEdit = actionMode === "edit" && decodedFormType === "draft";

  const showPublishButton =
    decodedFormType !== "draft" ||
    openedFromClone ||
    isCloneMode ||
    isDraftEdit;

  const pageHeading = useMemo(() => {
    if (title === "Create New Form") {
      return "Create New Form";
    }
    const formName =
      formData?.title?.trim() || navigationPageHeading?.trim() || "";
    if (title === "Update Form") {
      if (isCloneMode && !formName) {
        return "Copy of form";
      }
      return formName ? `Update ${formName}` : "Update Form";
    }
    if (actionMode === "edit" && formName) {
      return formName;
    }
    return title;
  }, [
    isCloneMode,
    formData?.title,
    title,
    actionMode,
    navigationPageHeading,
  ]);

  const breadcrumbPages = useMemo(() => {
    const pages = SUPER_ADMIN_BREADCRUMB(
      isCreateFlow
        ? SUPER_ADMIN_BREADCRUMBS_PAGES.CREATE_FORM_TEMPLATE
        : SUPER_ADMIN_BREADCRUMBS_PAGES.UPDATE_FORM_TEMPLATE,
      role
    );
    if (
      pageHeading &&
      pageHeading !== "Update Form" &&
      pageHeading !== "Create New Form" &&
      pages.length > 0
    ) {
      const next = [...pages];
      next[next.length - 1] = {
        ...next[next.length - 1],
        name: pageHeading,
      };
      return next;
    }
    return pages;
  }, [isCreateFlow, role, pageHeading]);

  const [request, setRequest] = useState({
    isRequested: false,
    isSuccess: false,
    isFailed: false,
    saveRequested: false,
    saveSuccess: false,
    saveFailed: false,
    submissionType: "",
  });

  useEffect(() => {
    templateFetchStarted.current = false;

    if (!form_uuid || !form_status) {
      setDecodedFormType(null);
      setActionMode("add");
      return;
    }

    try {
      const formType = decodeURIComponent(window.atob(form_status));
      if (formType === "publish" || formType === "draft") {
        setDecodedFormType(formType);
      } else {
        setDecodedFormType(null);
        toast.error("Invalid form status in the URL.");
      }
    } catch {
      setDecodedFormType(null);
      toast.error("Invalid form status in the URL.");
    }
    setActionMode("edit");
  }, [form_uuid, form_status]);

  useEffect(() => {
    if (
      actionMode !== "edit" ||
      !decodedFormType ||
      !form_uuid ||
      !categoriesLoaded ||
      templateFetchStarted.current
    ) {
      return;
    }

    templateFetchStarted.current = true;
    getFormTemplate();
  }, [actionMode, decodedFormType, form_uuid, categoriesLoaded, formCategories]);

  const onChangeHandler = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (formData?.form_category_id) {
      const isExistSubCats = formCategories.find(
        (x) => x.value === formData.form_category_id
      );
      if (
        isExistSubCats &&
        isExistSubCats.form_sub_categories &&
        isExistSubCats.form_sub_categories.length > 0
      ) {
        const data = isExistSubCats.form_sub_categories.map((x) => {
          const obj = {
            label: x.name,
            value: x.id,
          };
          return { ...x, ...obj };
        });
        setFormSubCategories([...data]);
        if (formData.form_sub_category_id) {
          setSelectedFormSubCategory(
            data.find((x) => x.value === formData.form_sub_category_id)
          );
        }
      } else {
        setFormSubCategories([]);
        setSelectedFormSubCategory(null);
      }
    }
  }, [formData]);

  const openInputModalHandler = (index) => {
    setDefaultFieldType(null);
    setShowInputModal(true);
    setSectionIndex(index);
  };

  const openLegacyAddFieldModal = (
    sectionIndex,
    fieldType = null,
    subSectionFieldIndex = null
  ) => {
    setSectionIndex(sectionIndex);
    setDefaultFieldType(fieldType);
    if (subSectionFieldIndex != null) {
      setFieldIndex(subSectionFieldIndex);
      setShowSubSectionInputModal(true);
      return;
    }
    setShowInputModal(true);
  };

  const closeInputModalHandler = () => {
    setShowInputModal(false);
    setDefaultFieldType(null);
  };

  const openSubSectionModalHandler = (index) => {
    setShowSubSectionModal(true);
    setSectionIndex(index);
  };

  const closeSubSectionModalHandler = () => {
    setShowSubSectionModal(false);
  };

  const openSubSectionInputModalHandler = (index, i) => {
    setDefaultFieldType(null);
    setShowSubSectionInputModal(true);
    setSectionIndex(index);
    setFieldIndex(i);
  };

  const closeSubSectionInputModalHandler = () => {
    setShowSubSectionInputModal(false);
    setDefaultFieldType(null);
  };

  const openSectionModalHandler = () => {
    setShowSectionModal(true);
  };

  const closeSectionModalHandler = () => {
    setShowSectionModal(false);
  };

  const openEditSectionModalHandler = (sectionIndex, fieldIndex, item) => {
    setFieldIndex(fieldIndex);
    setSectionIndex(sectionIndex);
    if (item.hasOwnProperty("required")) {
      item.required.toString();
    }
    setEditData(item);
    setShowEditSectionModal(true);
  };

  const closeEditSectionModalHandler = () => {
    setShowEditSectionModal(false);
  };

  const openEditSectionTitleModal = (
    sectionIndex,
    fieldIndex,
    item,
    subFieldIndex,
    type = "section"
  ) => {
    setSectionIndex(sectionIndex);
    setSubSectionIndex(fieldIndex);
    setEditData(item);
    setShowEditSectionTitle(true);
  };

  const closeSectionTitleHandler = () => {
    setShowEditSectionTitle(false);
  };

  const openEditSubSectionModalHandler = (
    sectionIndex,
    fieldIndex,
    item,
    subFieldIndex
  ) => {
    setFieldIndex(fieldIndex);
    setSectionIndex(sectionIndex);
    setSubFieldIndex(subFieldIndex);
    if (item.hasOwnProperty("required")) {
      item.required.toString();
    }
    setEditData(item);
    setShowEditSubSectionModal(true);
  };

  const closeEditSubSectionModalHandler = () => {
    setShowEditSubSectionModal(false);
  };

  const openConfirmationModalHandler = (
    sectionIndex,
    fieldIndex,
    subFieldIndex,
    type
  ) => {
    setFieldIndex(fieldIndex);
    setSectionIndex(sectionIndex);
    setSubFieldIndex(subFieldIndex);
    setShowConfirmationModal(true);
  };

  const closeConfirmationModalHandler = () => {
    setShowConfirmationModal(false);
  };

  const openSectionTitleConfirmationModalHandler = (sectionIndex) => {
    setSectionIndex(sectionIndex);
    setShowSectionTitleConfirmationModal(true);
  };

  const closeSectionTitleConfirmationModalHandler = () => {
    setShowSectionTitleConfirmationModal(false);
  };

  const openSubSectionConfirmationModalHandler = (
    sectionIndex,
    fieldIndex,
    subFieldIndex
  ) => {
    setFieldIndex(fieldIndex);
    setSectionIndex(sectionIndex);
    setSubFieldIndex(subFieldIndex);
    setShowSubSectionConfirmationModal(true);
  };

  const closeSubSectionConfirmationModalHandler = () => {
    setShowSubSectionConfirmationModal(false);
  };

  const fetchCategories = async () => {
    setRequest((prev) => ({ ...prev, isRequested: true }));
    try {
      const res =
        role === "sil"
          ? await api.silFormCategoriesApi()
          : await apiCall.formCategoriesRequest({ role });
      const categories = extractFormCategoriesFromResponse(res);
      const data = categories.map((x) => {
        const obj = {
          label: x.name,
          value: x.id,
        };
        return { ...x, ...obj };
      });
      setFormCategories([...data]);
      setRequest((prev) => ({ ...prev, isRequested: false, isSuccess: true }));
    } catch (err) {
      setRequest((prev) => ({ ...prev, isRequested: false, isFailed: true }));
      toast.error(err?.message || "Failed to load form categories.");
    } finally {
      setCategoriesLoaded(true);
    }
  };

  const getFormTemplate = async () => {
    setRequest((prev) => ({ ...prev, isRequested: true }));
    try {
      let url = null;
      if (roleAccess([USER_ROLE.Super_Admin])) {
        url = role === "hrm" ? "super-admin/hrm" : "super-admin";
      } else if (roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager])) {
        url =
          role === "sil"
            ? "sil/form/template"
            : role === "hrm"
            ? "sp/hrm/form_template"
            : "sp/form_template";
      }

      if (url === null) {
        throw new Error("You do not have permission to load this form template.");
      }

      const res = await apiGetRequest(
        roleAccess([USER_ROLE.Super_Admin])
          ? `${url}/form-template/show?form_uuid=${form_uuid}&form_type=${decodedFormType}`
          : `${url}?form_template_slug=${form_uuid}&form_type=${decodedFormType}`
      );

      if (res?.status !== 200) {
        throw new Error(
          res?.data?.error || res?.data?.message || "Failed to load form template."
        );
      }

      const templateData = res?.data?.data;
      if (!templateData) {
        throw new Error("Form template was not found.");
      }

      const formCat = resolveFormCategoryOptionForTemplate(
        templateData,
        formCategories,
        role
      );
      const sourceTitle = templateData.title?.trim() || "Untitled form";
      const payloadData = {
        ...formData,
        form_sub_category_id: templateData?.form_sub_category_id || null,
        description: templateData.description ?? "",
        title:
          decodedFormType === "draft"
            ? templateData.title
            : decodedFormType === "publish"
            ? `Copy of ${sourceTitle}`
            : templateData.title,
        form_category_id:
          role === "sil"
            ? templateData?.form_category_with_name?.id ??
              templateData?.category_id ??
              templateData?.form_category_id
            : templateData.form_category_id,
      };

      if (decodedFormType === "publish") {
        delete payloadData.uuid;
        delete payloadData.id;

        if (!roleAccess([USER_ROLE.Super_Admin])) {
          try {
            const resolveUrl =
              role === "sil"
                ? `sil/form/resolve-title?title=${encodeURIComponent(payloadData.title)}`
                : role === "hrm"
                ? `sp/hrm/form-templates/resolve-title?title=${encodeURIComponent(payloadData.title)}`
                : `sp/form-templates/resolve-title?title=${encodeURIComponent(payloadData.title)}`;
            const titleRes = await apiGetRequest(resolveUrl);
            const uniqueTitle =
              titleRes?.data?.title ?? titleRes?.data?.data?.title;
            if (uniqueTitle) {
              payloadData.title = uniqueTitle;
            }
          } catch {
            // Save will still de-duplicate the title on the server.
          }
        }
      } else {
        payloadData.uuid = templateData.uuid;
        payloadData.id = templateData.id;
      }

      if (formCat) {
        payloadData.form_category_id =
          formCat.value ?? formCat.id ?? payloadData.form_category_id;
      }

      const loadedTemplate = JSON.parse(templateData.template || "[]");
      setFormData(payloadData);
      setTemplate(loadedTemplate);
      if (formCat) {
        setselectedFormCategory(formCat);
      }
      setBaselineSnapshot(
        createFormBuilderSnapshot({
          template: loadedTemplate,
          formData: payloadData,
          selectedFormCategory: formCat,
          selectedFormSubCategory: null,
        })
      );
      setRequest((prev) => ({ ...prev, isRequested: false, isSuccess: true }));
    } catch (err) {
      setRequest((prev) => ({ ...prev, isRequested: false, isFailed: true }));
      toast.error(err?.message || "Failed to load form template.");
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    if (actionMode === "add" && !form_uuid) {
      setBaselineSnapshot(
        createFormBuilderSnapshot({
          template: [],
          formData: emptyCreateFormData(),
          selectedFormCategory: null,
          selectedFormSubCategory: null,
        })
      );
    }
  }, [actionMode, form_uuid]);

  const currentSnapshot = useMemo(
    () =>
      createFormBuilderSnapshot({
        template,
        formData,
        selectedFormCategory: selectedFormCategory,
        selectedFormSubCategory: selectedformSubCategory,
      }),
    [
      template,
      formData,
      selectedFormCategory,
      selectedformSubCategory,
    ]
  );

  const hasUnsavedChanges = useMemo(
    () =>
      baselineSnapshot
        ? !formBuilderSnapshotsEqual(currentSnapshot, baselineSnapshot)
        : false,
    [baselineSnapshot, currentSnapshot]
  );

  const restoreBaselineSnapshot = () => {
    if (!baselineSnapshot) {
      return;
    }

    setTemplate(_.cloneDeep(baselineSnapshot.template));
    setFormData(_.cloneDeep(baselineSnapshot.formData ?? emptyCreateFormData()));
    setselectedFormCategory(baselineSnapshot.selectedFormCategory);
    setSelectedFormSubCategory(baselineSnapshot.selectedFormSubCategory);
    setSectionIndex(null);
    setFieldIndex(null);
    setSubFieldIndex(null);
  };

  const navigateToFormsList = () => {
    if (role === "sil") {
      navigate("/forms-accommodation");
      return;
    }
    if (role === "hrm") {
      navigate("/forms-list-hrm");
      return;
    }
    navigate("/forms-list");
  };

  const handleExit = () => {
    if (
      !roleAccess([
        USER_ROLE.Super_Admin,
        USER_ROLE.Sp_Admin,
        USER_ROLE.Sp_manager,
      ])
    ) {
      return;
    }

    if (hasUnsavedChanges) {
      setShowExitConfirmationModal(true);
      return;
    }

    navigateToFormsList();
  };

  const submitFormTemplate = async (creationType) => {
    if (template && template.length === 0) {
      toast("Create at least One Section!");
      return;
    }

    const data = {
      ...formData,
      template: template,
      form_type: creationType,
    };

    if (isCloneMode) {
      delete data.uuid;
      delete data.id;
    }

    setRequest({
      ...request,
      saveRequested: true,
      submissionType: creationType,
    });

    if (role === "sil") {
      Object.assign(data, {
        category_id: data.form_category_id,
      });
    }

    const isEditingDraft =
      actionMode === "edit" && decodedFormType === "draft";
    const isPublishingDraft =
      isEditingDraft && creationType === "publish";

    try {
      let res = null;

      if (roleAccess([USER_ROLE.Super_Admin])) {
        const routeRole = role === "hrm" ? "super-admin/hrm" : "super-admin";
        if (isCreateFlow) {
          res = await apiPostRequest(`${routeRole}/form-template`, data);
        } else if (isPublishingDraft) {
          if (!formData.id) {
            throw new Error("Draft form is missing an id.");
          }
          res = await apiPutRequest(`${routeRole}/form-template/${form_uuid}`, {
            ...data,
            form_type: "draft",
          });
          if (res?.status === 200) {
            res = await apiPostRequest(
              `${routeRole}/form-template/draft-publish`,
              { id: formData.id }
            );
          }
        } else {
          res = await apiPutRequest(
            `${routeRole}/form-template/${form_uuid}`,
            data
          );
        }
      } else if (roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager])) {
        const routeRole =
          role === "sil"
            ? "sil/form"
            : role === "hrm"
            ? "sp/hrm/form-templates"
            : "sp/form-templates";

        if (isCreateFlow) {
          res = await apiPostRequest(`${routeRole}/create`, data);
        } else if (isPublishingDraft) {
          if (!formData.id) {
            throw new Error("Draft form is missing an id.");
          }
          const draftUpdateUrl =
            role === "sil"
              ? `${routeRole}/update?id=${formData.uuid}&form_type=draft`
              : role === "hrm"
              ? `sp/hrm/provider_form_template?form_template_slug=${form_uuid}&form_type=draft`
              : `sp/provider_form_template?form_template_slug=${form_uuid}&form_type=draft`;

          res = await apiPostRequest(draftUpdateUrl, {
            ...data,
            form_type: "draft",
            form_template_slug: form_uuid,
          });

          if (res?.status === 200) {
            const draftPublishUrl =
              role === "sil"
                ? "sil/form/draft-publish"
                : role === "hrm"
                ? "sp/hrm/form-templates/draft-publish"
                : "sp/form-templates/draft-publish";
            res = await apiPostRequest(draftPublishUrl, { id: formData.id });
          }
        } else {
          const url =
            role === "sil"
              ? `${routeRole}/update?id=${formData.uuid}&form_type=${decodedFormType}`
              : role === "hrm"
              ? `sp/hrm/provider_form_template?form_template_slug=${form_uuid}&form_type=${decodedFormType}`
              : `sp/provider_form_template?form_template_slug=${form_uuid}&form_type=${decodedFormType}`;

          res = await apiPostRequest(url, data);
        }

        //   await apiPostRequest(
        //     `sp/hrm/provider_form_template?form_template_slug=${form_uuid}&form_type=${form_status}`,
        //     data
        //   ));

        // ? await apiPostRequest(`${routeRole}/provider_form_template`, data)
        // : await apiPostRequest(
        //     `${routeRole}/provider_form_template?form_template_slug=${form_uuid}&form_type=${form_status}`,
        //     data
        //   );
      }

      if (res === null) return;
      if (
        res.status !== 201 &&
        decodedFormType &&
        decodedFormType === "publish"
      ) {
        setRequest({
          ...request,
          saveRequested: false,
          submissionType: null,
          saveFailed: false,
        });
        throw new Error(res.data.error);
      }

      if (res.status === 201 || (res.status === 200 && isCreateFlow)) {
        setRequest({
          ...request,
          saveRequested: false,
          submissionType: null,
          saveSuccess: true,
        });
        setFormData({
          title: "",
          form_category_id: null,
          form_sub_category_id: null,
          description: "",
        });
        setTemplate([]);
        setSectionIndex(null);
        setFieldIndex(null);
        setSubFieldIndex(null);
        toast.success("Form Template created successfully");
        role === "sil"
          ? navigate("/forms-accommodation")
          : role === "hrm"
          ? navigate("/forms-list-hrm")
          : navigate("/forms-list");
      } else if (res.status === 200) {
        toast.success(
          isPublishingDraft
            ? "Form Template published successfully"
            : "Form Template updated successfully"
        );
        role === "sil"
          ? navigate("/forms-accommodation")
          : role === "hrm"
          ? navigate("/forms-list-hrm")
          : navigate("/forms-list");
      }
      setRequest({
        ...request,
        saveRequested: false,
        submissionType: null,
        saveFailed: false,
      });
    } catch (err) {
      setRequest({
        ...request,
        saveRequested: false,
        submissionType: null,
        saveFailed: false,
      });
      // console.log("err", err);
      toast.error(
        err.hasOwnProperty("message") && err.message
          ? err.message
          : "Something went wrong!"
      );
    }
  };

  const addInputFieldHandler = (data) => {
    const list = _.cloneDeep(template);
    if (parseBooleanVal(data.required)) {
      data.required = true;
    } else {
      data.required = false;
    }
    list[sectionIndex].input_fields.push(data);
    setTemplate(list);
  };

  const updateFieldHandler = (data) => {
    const list = _.cloneDeep(template);
    if (parseBooleanVal(data.required)) {
      data.required = true;
    } else {
      data.required = false;
    }
    list[sectionIndex].input_fields[fieldIndex] = data;

    setTemplate(list);
  };

  const updateSubSectionFieldHandler = (data) => {
    const list = _.cloneDeep(template);
    if (parseBooleanVal(data.required)) {
      data.required = true;
    } else {
      data.required = false;
    }
    list[sectionIndex].input_fields[fieldIndex].sub_fields[subFieldIndex] =
      data;
    setTemplate(list);
  };

  const deleteFieldHandler = () => {
    const list = _.cloneDeep(template);
    list[sectionIndex].input_fields.splice(fieldIndex, 1);
    setTemplate(list);
    setShowConfirmationModal(false);
  };

  const deleteSectionHandler = () => {
    const list = _.cloneDeep(template);
    list.splice(sectionIndex, 1);
    setTemplate(list);
    setShowSectionTitleConfirmationModal(false);
  };

  const deleteSubSectionFieldHandler = () => {
    const list = _.cloneDeep(template);
    if (subFieldIndex) {
      list[sectionIndex].input_fields[fieldIndex].sub_fields.splice(
        subFieldIndex,
        1
      );
    } else list[sectionIndex].input_fields.splice(fieldIndex, 1);
    setTemplate(list);
    setShowSubSectionConfirmationModal(false);
  };

  const addSubSectionHandler = (data) => {
    data.type = "sub_section";
    data.lable = "";
    data.sub_fields = [];
    data.isAddOther = parseBooleanVal(data.isAddOther);
    const list = _.cloneDeep(template);
    list[sectionIndex].input_fields.push(data);
    setTemplate(list);
  };

  const addSectionHandler = (data) => {
    const list = _.cloneDeep(template);
    data.input_fields = [];
    list.push(data);
    setTemplate(list);
  };

  const editSectionTitleHandler = (data) => {
    const list = _.cloneDeep(template);
    if (data.type === "sub_section") {
      list[sectionIndex].input_fields[subSectionIndex].isAddOther =
        parseBooleanVal(data.isAddOther);
      list[sectionIndex].input_fields[subSectionIndex].section_title =
        data.section_title;
    } else {
      list[sectionIndex].section_title = data.section_title;
    }
    setTemplate(list);
    setShowEditSectionTitle(false);
  };

  const addSubSectionInputFieldHandler = (data) => {
    const list = _.cloneDeep(template);
    if (parseBooleanVal(data.required)) {
      data.required = true;
    } else {
      data.required = false;
    }
    list[sectionIndex].input_fields[fieldIndex].sub_fields.push(data);
    setTemplate(list);
  };

  return (
    <div>
      <div className='min-h-full'>
        <SideBar />
        <div
          className={`${
            sideBarPadding
              ? "lg:pl-[4rem] duration-300 flex flex-col"
              : "lg:pl-64 duration-300 flex flex-col"
          }`}
        >
          <main className='flex-1'>
            <Header
              title={pageHeading}
              titleBadge={
                <FormScopeBadge scope={resolveFormScopeFromRole(role)} />
              }
              desc='Supercharge your business with customization on the standard forms.'
              breadcrumb={<Breadcrumb pages={breadcrumbPages} />}
            />
            {/* <div className='sm:px-6 lg:px-8 my-3'>
              <Breadcrumb
                pages={SUPER_ADMIN_BREADCRUMB(
                  title === "Create New Form" ||
                    (decodedFormType && decodedFormType === "publish")
                    ? SUPER_ADMIN_BREADCRUMBS_PAGES.CREATE_FORM_TEMPLATE
                    : SUPER_ADMIN_BREADCRUMBS_PAGES.UPDATE_FORM_TEMPLATE,
                  role
                )}
              />
            </div> */}
            {request.isRequested ? (
              <CircularLoader
                classes='flex justify-center items-center'
                classloader='loader-l'
              />
            ) : (
              <div className='form-builder-page py-3 px-4 sm:px-6 lg:px-8 w-full max-w-[1440px]'>
                <div className='form-builder-meta-card'>
                  <div className='form-builder-meta-toolbar'>
                    <p className='form-builder-meta-card-header'>Form details</p>
                    <div className='form-builder-actions form-builder-actions--inline'>
                      <PdfFormImportButton
                        endpoint={resolvePdfImportEndpoint({
                          isSuperAdmin: roleAccess([USER_ROLE.Super_Admin]),
                          role,
                        })}
                        hasExistingFields={template.some(
                          (section) => (section.input_fields || []).length > 0
                        )}
                        onImported={(draft) => {
                          setTemplate(draft.template);
                          setPdfImportReview({
                            documentKind: draft.document_kind,
                            reviewRequired: Boolean(draft.review_required),
                            warnings: draft.warnings || [],
                          });
                          if (draft.title) {
                            setFormData((current) => ({
                              ...current,
                              title: draft.title,
                            }));
                          }
                        }}
                      />
                      <FormBuilderExperienceControls
                        template={template}
                        formTitle={formData.title}
                        formDescription={formData.description}
                      />
                      <FormBuilderDiscardButton
                        hasChanges={hasUnsavedChanges}
                        onDiscard={() => {
                          restoreBaselineSnapshot();
                          setPdfImportReview(null);
                        }}
                        isDisabled={request.isRequested || request.saveRequested}
                      />
                      <CustomButton
                        type='button'
                        label='Exit'
                        variant='danger'
                        cssClass='form-btn-cancel'
                        clickHandler={(e) => {
                          e.preventDefault();
                          handleExit();
                        }}
                      />
                      {showPublishButton ? (
                        <CustomButton
                          clickHandler={() => {
                            if (isUserGracePeriodOver) {
                              return;
                            }
                            setShowConfirmationModalPublish(true);
                          }}
                          isDisabled={
                            !formData.title?.trim() ||
                            !formData.form_category_id ||
                            request.saveRequested ||
                            isUserGracePeriodOver
                          }
                          Icon={<MdPublish />}
                          showLoading={
                            request.saveRequested &&
                            request.submissionType === "publish"
                          }
                          label='Publish'
                        />
                      ) : null}
                      <CustomButton
                        clickHandler={() => {
                          if (isUserGracePeriodOver) {
                            return;
                          }
                          submitFormTemplate("draft");
                        }}
                        isDisabled={
                          !formData.title?.trim() ||
                          !formData.form_category_id ||
                          request.saveRequested ||
                          isUserGracePeriodOver
                        }
                        Icon={<RiDraftFill />}
                        showLoading={
                          request.saveRequested &&
                          request.submissionType === "draft"
                        }
                        label={`${
                          isCreateFlow || openedFromClone
                            ? "Save as draft"
                            : "Update as draft"
                        }`}
                      />
                    </div>
                  </div>
                  <div className='col-span-12 md:col-span-6 form-builder-meta-field did-floating-label-content'>
                    <label htmlFor='form-title' className='did-floating-label'>
                      Title
                    </label>
                    <input
                      id='form-title'
                      value={formData?.title}
                      type='text'
                      className='did-floating-input'
                      name='title'
                      onChange={onChangeHandler}
                    />
                  </div>
                  <div className='col-span-12 md:col-span-6 form-builder-meta-field did-floating-label-content'>
                    <label className='did-floating-label'>Form Category</label>
                    {role === "sil" ? (
                      <FormCategorySelect
                        role="sil"
                        categories={formCategories}
                        selectedOption={selectedFormCategory}
                        onCategoryCreated={(category) => {
                          setFormCategories((prev) => [...prev, category]);
                        }}
                        onChange={(e) => {
                          setselectedFormCategory(e);
                          setFormData({
                            ...formData,
                            form_category_id: e?.value ?? null,
                          });
                          setFormCatError("");
                        }}
                      />
                    ) : (
                      <FormCategorySelect
                        role={role}
                        categories={formCategories}
                        selectedOption={selectedFormCategory}
                        onCategoryCreated={(category) => {
                          setFormCategories((prev) => [...prev, category]);
                        }}
                        onChange={(e) => {
                          setselectedFormCategory(e);
                          setFormData({
                            ...formData,
                            form_category_id: e?.value ?? null,
                            form_sub_category_id: null,
                          });
                          setSelectedFormSubCategory(null);
                          setFormCatError("");
                        }}
                      />
                    )}
                    {formCatError && (
                      <span className='text-sm text-red-500'>
                        This field is required
                      </span>
                    )}
                  </div>

                  {formSubCategories && formSubCategories.length > 0 && (
                    <div className='col-span-12 md:col-span-6 form-builder-meta-field did-floating-label-content'>
                      <label className='did-floating-label'>
                        Form Sub Category
                      </label>
                      <SelectOption
                        isClearable={true}
                        isSearch={false}
                        data={formSubCategories}
                        selectedOption={selectedformSubCategory}
                        handleChange={(e) => {
                          setSelectedFormSubCategory(e);
                          setFormData({
                            ...formData,
                            form_sub_category_id: e ? e.value : null,
                          });
                        }}
                      />
                    </div>
                  )}
                  <div className='col-span-12 form-builder-meta-field did-floating-label-content'>
                    <label className='did-floating-label'>Description</label>
                    <textarea
                      value={formData.description}
                      className='form-textarea form-builder-meta-textarea'
                      rows={2}
                      name='description'
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>

                <FormBuilderSectionList
                  template={template}
                  setTemplate={setTemplate}
                  importReview={pdfImportReview}
                  onDismissImportReview={() => setPdfImportReview(null)}
                  openInputModalHandler={openInputModalHandler}
                  openSubSectionModalHandler={openSubSectionModalHandler}
                  openSubSectionInputModalHandler={openSubSectionInputModalHandler}
                  openEditSectionTitleModal={openEditSectionTitleModal}
                  openEditSectionModalHandler={openEditSectionModalHandler}
                  openEditSubSectionModalHandler={openEditSubSectionModalHandler}
                  openSectionTitleConfirmationModalHandler={
                    openSectionTitleConfirmationModalHandler
                  }
                  openSubSectionConfirmationModalHandler={
                    openSubSectionConfirmationModalHandler
                  }
                  openConfirmationModalHandler={openConfirmationModalHandler}
                  openSectionModalHandler={openSectionModalHandler}
                  onLegacyAddFieldRequest={openLegacyAddFieldModal}
                />
              </div>
            )}
          </main>
        </div>
      </div>

      {showInputModal && (
        <InputCreationForm
          formCategoryId={selectedFormCategory ? selectedFormCategory.id : null}
          showModal={showInputModal}
          title='Add Section Input Field'
          dataSubmitHandler={addInputFieldHandler}
          closeModalHandler={closeInputModalHandler}
          template={template}
          sectionIndex={sectionIndex}
          subSectionIndex={subSectionIndex}
          defaultFieldType={defaultFieldType}
        />
      )}
      {showSubSectionModal && (
        <SectionCreationForm
          title='Add New Sub Section'
          showModal={showSubSectionModal}
          type='sub_section'
          dataSubmitHandler={addSubSectionHandler}
          closeModalHandler={closeSubSectionModalHandler}
        />
      )}
      {showSubSectionInputModal && (
        <InputCreationForm
          formCategoryId={selectedFormCategory ? selectedFormCategory.id : null}
          title='Add Sub Section Input Field'
          showModal={showSubSectionInputModal}
          dataSubmitHandler={addSubSectionInputFieldHandler}
          closeModalHandler={closeSubSectionInputModalHandler}
          sectionIndex={sectionIndex}
          subSectionIndex={subSectionIndex}
          defaultFieldType={defaultFieldType}
        />
      )}
      {showSectionModal && (
        <SectionCreationForm
          title='Add New Section'
          showModal={showSectionModal}
          type='section'
          dataSubmitHandler={addSectionHandler}
          closeModalHandler={closeSectionModalHandler}
        />
      )}
      {showEditSectionTitle && (
        <SectionCreationForm
          title='Edit Section Title'
          showModal={showEditSectionTitle}
          type={
            editData && editData.type === "sub_section"
              ? "sub_section"
              : "section"
          }
          editData={editData}
          dataSubmitHandler={editSectionTitleHandler}
          closeModalHandler={closeSectionTitleHandler}
        />
      )}
      {showEditSectionModal && (
        <InputCreationForm
          formCategoryId={selectedFormCategory ? selectedFormCategory.id : null}
          title='Edit Section Input Field'
          showModal={showEditSectionModal}
          template={template}
          editData={editData}
          dataSubmitHandler={updateFieldHandler}
          closeModalHandler={closeEditSectionModalHandler}
          sectionIndex={sectionIndex}
          subSectionIndex={subSectionIndex}
        />
      )}
      {showEditSubSectionModal && (
        <InputCreationForm
          formCategoryId={selectedFormCategory ? selectedFormCategory.id : null}
          title='Edit Sub Section Input Field'
          showModal={showEditSubSectionModal}
          editData={editData}
          dataSubmitHandler={updateSubSectionFieldHandler}
          closeModalHandler={closeEditSubSectionModalHandler}
          sectionIndex={sectionIndex}
          subSectionIndex={subSectionIndex}
        />
      )}

      <ConfirmationModal
        showModal={showConfirmationModal}
        closeModalHandler={closeConfirmationModalHandler}
        submitHandler={deleteFieldHandler}
      />
      <ConfirmationModal
        showModal={showSectionTitleConfirmationModal}
        closeModalHandler={closeSectionTitleConfirmationModalHandler}
        submitHandler={deleteSectionHandler}
      />
      <ConfirmationModal
        showModal={showSubSectionConfirmationModal}
        closeModalHandler={closeSubSectionConfirmationModalHandler}
        submitHandler={deleteSubSectionFieldHandler}
      />
      {showConfirmationModalPublish && (
        <SweetAlertConfirmationModal
          isOpen={showConfirmationModalPublish}
          title='Confirm your action?'
          content='Are you sure to publish this form?'
          setIsConfirm={(e) => {
            if (e) {
              setShowConfirmationModalPublish(false);
              submitFormTemplate("publish");
            } else {
              setShowConfirmationModalPublish(false);
            }
          }}
        />
      )}
      {showExitConfirmationModal && (
        <SweetAlertConfirmationModal
          isOpen={showExitConfirmationModal}
          title='Leave without saving?'
          content='You have unsaved changes. Exit anyway, or stay and use Discard changes to restore the last saved version.'
          setIsConfirm={(confirmed) => {
            setShowExitConfirmationModal(false);
            if (confirmed) {
              navigateToFormsList();
            }
          }}
        />
      )}
    </div>
  );
};

export default CreateFormTemplate;
